import React, { useEffect } from "react";
import AOS from "aos";
const ProgramsOverview = () => {
  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });
    window.scrollTo({ behavior: "smooth", top: 0 });
  }, []);

  const sixMonthFeatures = [
    "6 Months Live Internship",
    "Product Development Experience",
    "Professional Mentorship",
    "Real Client Projects",
    "Career Guidance",
    "Soft Skills Training",
    "Internship Certificate ",
    "Employment Offer "
  ];
  const FiveMonthFeatures = [
    " Weekend Classes ",
    "Industry Mentors",
    "Real Projects",
    "Assignment Reviews ",
    "Career Guidance ",
    "Portfolio Development ",
    "Completion Certificate"
  ];
  const ThreeMonthFeatures = [
    " Weekly Classes ",
    "Resume Building ",
    "LinkedIn Profile",
    "Interview Preparation",
    "Job Opening Assistance",
    "Technical Guidance",
    "Portfolio Review"
  ];
  const fortyMonthFeatures = [
    "45 Days Live Internship",
    "Resume Building ",
    "LinkedIn Profile",
    "Interview Preparation",
    "Job Opening Assistance",
    "Technical Guidance",
    "Portfolio Review"
  ];

  const jobGuaranteeFeatures = [
    "100% job placement",
    "Interview preparation",
    "Periodic Salary Increments based on performance",
  ];

  return (
    <section className="overview bg-card">
      <div className="container px-4 py-5">
        <div className="text-center mb-5">
          <h2
            className="display-5 text-light fw-bold mb-5 pt-5"
            style={{ fontFamily: "'Merriweather', serif" }}
            data-aos="fade-down"
          >
            Career Through{" "}
            <span className="gradient-text" style={{ fontWeight: "800" }}>
              TECH BRIDGE
            </span>
          </h2>
          <p className="fs-5 mb-4 text-light">
            Comprehensive programs designed for your success
          </p>
        </div>

        <div className="row g-4">
          {/* 6-Month Program Card */}
          <div className="col-md-6" data-aos="fade-right">
            <div
              className="card card-hover border rounded-1"
              data-testid="card-6month-program"
            >
              <img
                src="https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/techbridge19855_IMG.jpg"
                alt="Professional coding workspace"
                className="card-img-top rounded-top"
                style={{ height: "200px", objectFit: "cover" }}
                data-testid="img-6month-workspace"
              />
              <div className="card-body p-4">
                <div className="gradient-bg w-25 h-1 rounded mb-3"></div>
                <h3
                  className="card-title h5 fw-bold mb-3"
                  data-testid="text-6month-title"
                >
                  6-MONTH WEEKEND INTERNSHIP
                </h3>
                <p
                  className="card-text text-muted-foreground mb-4"
                  data-testid="text-6month-description"
                >
                  Internship training with hands-on projects, mentorship, and
                  career support.
                </p>
                <ul className="list-unstyled mb-4">
                  {sixMonthFeatures.map((feature, index) => (
                    <li
                      key={index}
                      className="d-flex align-items-center mb-2"
                      data-testid={`feature-6month-${index}`}
                    >
                      <i className="fas fa-check-circle text-accent me-2"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
                {/* <a
                  href="/6-month-program"
                  className="btn w-100 gradient-bg text-white py-3 rounded-pill fw-semibold"
                  data-testid="button-learn-more-6month"
                >
                  Learn More
                </a> */}
              </div>
            </div>
          </div>

          {/* Job Guarantee Program Card */}
          <div className="col-md-6" data-aos="fade-left">
            <div
              className="card card-hover bg-background border border-border rounded-xl h-100"
              data-testid="card-job-guarantee"
            >
              <img
                src="https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/techbridge64060_IMG.jpg"
                alt="Diverse tech professionals collaborating"
                className="card-img-top rounded-top"
                style={{ height: "200px", objectFit: "cover" }}
                data-testid="img-job-guarantee-team"
              />
              <div className="card-body p-4">
                <div className="bg-accent w-25 h-1 rounded mb-3"></div>
                <h3
                  className="card-title h5 fw-bold mb-3"
                  data-testid="text-job-guarantee-title"
                >
                  5-MONTH WEEKEND INTERNSHIP 
                </h3>
                <p
                  className="card-text text-muted-foreground mb-4"
                  data-testid="text-job-guarantee-description"
                >
                  Guaranteed job placement program.
                </p>
                <ul className="list-unstyled mb-4">
                  {FiveMonthFeatures.map((feature, index) => (
                    <li
                      key={index}
                      className="d-flex align-items-center mb-2"
                      data-testid={`feature-job-guarantee-${index}`}
                    >
                      <i className="fas fa-check-circle text-accent me-2"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
                {/* <a
                  href="/job-guarantee"
                  className="btn w-100 gradient-bg text-light py-3 rounded-pill fw-semibold border border-border"
                  style={{ transition: "background-color 0.3s ease" }}
                  data-testid="button-learn-more-job-guarantee"
                >
                  Learn More
                </a> */}
              </div>
            </div>
          </div>

          <div className="col-md-6" data-aos="fade-left">
            <div
              className="card card-hover bg-background border border-border rounded-xl h-100"
              data-testid="card-job-guarantee"
            >
              <img
                src="https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/techbridge48398_IMG.jpg"
                alt="Diverse tech professionals collaborating"
                className="card-img-top rounded-top"
                style={{ height: "200px", objectFit: "cover" }}
                data-testid="img-job-guarantee-team"
              />
              <div className="card-body p-4">
                <div className="bg-accent w-25 h-1 rounded mb-3"></div>
                <h3
                  className="card-title h5 fw-bold mb-3"
                  data-testid="text-job-guarantee-title"
                >
                 3-MONTH PROFESSIONAL INTERNSHIP 
                </h3>
                <p
                  className="card-text text-muted-foreground mb-4"
                  data-testid="text-job-guarantee-description"
                >
                  Guaranteed job placement program.
                </p>
                <ul className="list-unstyled mb-4">
                  {ThreeMonthFeatures.map((feature, index) => (
                    <li
                      key={index}
                      className="d-flex align-items-center mb-2"
                      data-testid={`feature-job-guarantee-${index}`}
                    >
                      <i className="fas fa-check-circle text-accent me-2"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
                {/* <a
                  href="/job-guarantee"
                  className="btn w-100 gradient-bg text-light py-3 rounded-pill fw-semibold border border-border"
                  style={{ transition: "background-color 0.3s ease" }}
                  data-testid="button-learn-more-job-guarantee"
                >
                  Learn More
                </a> */}
              </div>
            </div>
          </div>

          <div className="col-md-6" data-aos="fade-left">
            <div
              className="card card-hover bg-background border border-border rounded-xl h-100"
              data-testid="card-job-guarantee"
            >
              <img
                src="	https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/techbridge38609_IMG.png"
                alt="Diverse tech professionals collaborating"
                className="card-img-top rounded-top"
                style={{ height: "200px", objectFit: "cover" }}
                data-testid="img-job-guarantee-team"
              />
              <div className="card-body p-4">
                <div className="bg-accent w-25 h-1 rounded mb-3"></div>
                <h3
                  className="card-title h5 fw-bold mb-3"
                  data-testid="text-job-guarantee-title"
                >
                  Internship - 45 days
                </h3>
                <p
                  className="card-text text-muted-foreground mb-4"
                  data-testid="text-job-guarantee-description"
                >
                  Guaranteed job placement program.
                </p>
                <ul className="list-unstyled mb-4">
                  {fortyMonthFeatures.map((feature, index) => (
                    <li
                      key={index}
                      className="d-flex align-items-center mb-2"
                      data-testid={`feature-job-guarantee-${index}`}
                    >
                      <i className="fas fa-check-circle text-accent me-2"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
                {/* <a
                  href="/job-guarantee"
                  className="btn w-100 gradient-bg text-light py-3 rounded-pill fw-semibold border border-border"
                  style={{ transition: "background-color 0.3s ease" }}
                  data-testid="button-learn-more-job-guarantee"
                >
                  Learn More
                </a> */}
              </div>
            </div>
          </div>
        </div>
        <div className="my-3 d-flex justify-content-center">
          <div className="d-flex w-50 mt-5 align-items-center justify-content-center text-center border rounded-pill px-4 py-2 gap-3 professional-glow prize-amount">
            <p className="fs-4 fw-bold m-0">
              <a
                href="/enquire"

                className="text-decoration-none"
                style={{ color: "rgb(0 253 255)" }}
              >
                Enquire Now
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProgramsOverview;
